<!-- Generator: Adobe Illustrator 26.4.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg
    version="1.1"
    id="Ebene_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 809.4 188.6"
    style="enable-background:new 0 0 809.4 188.6;"
    xml:space="preserve"
>
    <style type="text/css">
        .st0 {
            fill-rule: evenodd;
            clip-rule: evenodd;
            fill: #d30d2d;
        }
        .st1 {
            fill-rule: evenodd;
            clip-rule: evenodd;
        }
    </style>
    <path
        class="st0"
        d="M786.1,70.8c8.1,0,14.7,6.6,14.7,14.7c0,8.1-6.6,14.7-14.7,14.7c-8.1,0-14.7-6.6-14.7-14.7
	C771.5,77.4,778,70.8,786.1,70.8"
    />
    <polygon
        class="st1"
        points="739.8,181.4 739.8,119 799.9,119 799.9,132 762.4,132 762.4,143.7 787.3,143.7 787.3,156.7 
	762.4,156.7 762.4,168.4 800.9,168.4 800.9,181.4 739.8,181.4 "
    />
    <polygon
        class="st0"
        points="751.2,71 740.9,67.1 730.5,63.2 720.1,59.5 709.6,55.9 699,52.4 688.5,49.1 677.9,45.8 667.3,42.7 
	656.6,39.7 645.9,36.9 635.1,34.1 624.4,31.6 613.6,29.1 602.7,26.7 591.9,24.5 581,22.3 570.1,20.4 559.2,18.5 548.3,16.8 
	537.3,15.2 526.3,13.7 515.3,12.3 504.4,11.1 493.3,10.1 482.3,9.1 471.3,8.3 460.3,7.5 449.2,7 438.1,6.5 427.1,6.2 416,6 405,6 
	393.9,6 382.8,6.2 371.8,6.5 360.7,7 349.7,7.5 338.6,8.3 327.6,9.1 316.6,10.1 305.6,11.1 294.5,12.3 283.6,13.7 272.6,15.2 
	261.6,16.8 250.7,18.5 239.8,20.4 228.9,22.3 218,24.5 207.2,26.7 196.3,29.1 185.5,31.6 174.8,34.1 164,36.9 153.3,39.7 
	142.7,42.7 132,45.8 121.4,49.1 110.8,52.4 100.3,55.9 89.8,59.5 79.4,63.2 69,67.1 58.7,71 61.1,77.5 71.3,73.6 81.7,69.8 92,66 
	102.4,62.5 112.9,59 123.4,55.7 133.9,52.5 144.5,49.4 155.1,46.4 165.7,43.6 176.4,40.9 187.1,38.3 197.8,35.8 208.5,33.5 
	219.3,31.2 230.1,29.1 240.9,27.2 251.8,25.3 262.6,23.6 273.5,22 284.4,20.6 295.3,19.2 306.2,18 317.2,16.9 328.1,16 339.1,15.2 
	350.1,14.5 361,13.9 372,13.4 383,13.1 394,12.9 405,12.9 415.9,12.9 426.9,13.1 437.9,13.4 448.9,13.9 459.9,14.5 470.8,15.2 
	481.8,16 492.7,16.9 503.6,18 514.6,19.2 525.5,20.6 536.4,22 547.3,23.6 558.1,25.3 569,27.2 579.8,29.1 590.6,31.2 601.3,33.5 
	612.1,35.8 622.8,38.3 633.5,40.9 644.2,43.6 654.8,46.4 665.4,49.4 676,52.5 686.5,55.7 697,59 707.5,62.5 717.9,66 728.2,69.8 
	738.5,73.6 748.8,77.5 751.2,71 "
    />
    <polygon
        class="st1"
        points="483.2,181.4 483.2,119 505.9,119 505.9,143.7 528.5,143.7 528.5,119 551.1,119 551.1,181.4 
	528.5,181.4 528.5,156.7 505.9,156.7 505.9,181.4 483.2,181.4 "
    />
    <polygon class="st1" points="204.5,181.4 204.5,119 227.2,119 227.2,181.4 204.5,181.4 " />
    <polygon
        class="st1"
        points="84.6,119 107.2,181.4 125.3,181.4 137.8,147 150.2,181.4 168.3,181.4 190.9,119 172.8,119 159.8,154.9 
	146.8,119 128.7,119 115.7,154.9 102.7,119 84.6,119 "
    />
    <polygon
        class="st1"
        points="655.6,181 655.6,119.4 675.3,119.5 707.1,154.4 707,119.4 724.9,119.4 724.9,181 705.1,181 
	673.5,144.6 673.5,181 655.6,181 "
    />
    <path
        class="st1"
        d="M6.8,167.5l11.8-7.9l0,0c2.7,2.6,5.3,4.5,8.5,5.8c1.5,0.6,5.6,1.7,7.3,2c2.1,0.4,4.9,0.6,7.5,0.6
	c4,0,6.5-0.7,8.9-1.8c2.4-1,3-2.8,2.8-4.2c-0.3-1.7-3.1-4.6-8.1-5.7c-5.1-1.1-9.5-1.9-14.3-3.1c-5.6-1.3-10.9-3.1-14.3-5.8
	c-3.8-3.1-5.3-7.9-5.2-12c0.1-3.9,1.8-7.5,4.3-10.6c2.4-2.9,7.2-6,11.1-7.3c3.6-1.2,8.9-2.2,15.2-2.2c6,0,12.6,1.3,16.8,2.8
	c4.1,1.5,7.1,2.4,13.3,7c-0.1,0.1-11.5,8-11.5,8c-2.3-1.3-0.8-0.4-3.3-1.7c-1.7-0.8-4.2-1.9-6-2.3c-2.6-0.8-4.2-1.1-7.1-1.2
	c-3.3-0.1-5.7,0.5-7.9,1.5c-2.2,0.9-3.3,2.6-3.3,4.1c0,2.2,2.2,3.7,7.2,4.9c5.1,1.2,9.6,1.8,15.4,3.4c5.7,1.4,10.7,3.5,14.8,6.3
	c4,2.7,6.9,6.3,6.9,12c0,4.2-1.2,7.4-4,10.6c-2.8,3.1-6.4,6-11.5,7.7c-5.1,1.8-13,3.3-19.7,3.3c-5.7,0-10.5-0.5-14.9-1.5l0,0
	c-4-0.9-7-2.2-10.3-4C12.9,174.2,9.3,170.6,6.8,167.5C6.8,167.6,6.8,167.5,6.8,167.5L6.8,167.5z"
    />
    <path
        class="st1"
        d="M313.3,167.3l11.8-7.9h0c2.7,2.6,5.3,4.5,8.5,5.8c1.5,0.6,5.6,1.7,7.3,2c2.1,0.4,4.9,0.6,7.5,0.6
	c4,0,6.5-0.8,8.9-1.8c2.4-1,3-2.7,2.7-4.2c-0.3-1.7-3.1-4.5-8.1-5.7c-5.1-1.1-9.5-1.9-14.3-3.1c-5.6-1.3-10.9-3.1-14.3-5.8
	c-3.8-3.1-5.3-7.9-5.2-12c0.1-3.9,1.8-7.5,4.3-10.7c2.4-2.9,7.2-6,11.1-7.2c3.6-1.2,8.9-2.2,15.1-2.2c6,0,12.6,1.3,16.8,2.8
	c4.1,1.5,7.1,2.4,13.3,7c-0.1,0-11.5,8-11.5,8c-2.2-1.3-0.8-0.4-3.3-1.7c-1.7-0.9-4.2-1.9-6.1-2.3c-2.6-0.8-4.2-1.1-7.1-1.2
	c-3.3-0.1-5.7,0.5-7.9,1.5c-2.2,0.9-3.3,2.6-3.3,4.1c0,2.2,2.3,3.6,7.2,4.9c5.1,1.2,9.6,1.8,15.4,3.3c5.7,1.4,10.7,3.5,14.8,6.4
	c4,2.7,6.9,6.3,6.9,12c0,4.2-1.1,7.5-4,10.7c-2.8,3.1-6.4,5.9-11.5,7.7c-5.1,1.8-12.9,3.2-19.7,3.2c-5.7,0-10.5-0.5-14.8-1.5l0,0
	c-4-0.9-7-2.2-10.3-4c-4.2-2.2-7.8-5.8-10.3-8.8C313.3,167.4,313.3,167.4,313.3,167.3L313.3,167.3z"
    />
    <path
        class="st1"
        d="M236.4,167.3l11.8-7.9l0,0c2.7,2.6,5.3,4.5,8.5,5.8c1.5,0.6,5.6,1.7,7.3,2c2.1,0.4,4.9,0.6,7.5,0.6
	c4,0,6.5-0.8,8.9-1.8c2.4-1,3-2.7,2.8-4.2c-0.3-1.7-3.1-4.5-8.1-5.7c-5.1-1.1-9.5-1.9-14.3-3.1c-5.6-1.3-10.9-3.1-14.3-5.8
	c-3.8-3.1-5.3-7.9-5.2-12c0.1-3.9,1.8-7.5,4.3-10.7c2.4-2.9,7.2-6,11.1-7.2c3.6-1.2,8.9-2.2,15.1-2.2c6,0,12.6,1.3,16.8,2.8
	c4.1,1.5,7.1,2.4,13.3,7c-0.1,0-11.5,8-11.5,8c-2.2-1.3-0.8-0.4-3.3-1.7c-1.7-0.9-4.2-1.9-6-2.3c-2.6-0.8-4.2-1.1-7.1-1.2
	c-3.3-0.1-5.7,0.5-7.9,1.5c-2.2,0.9-3.3,2.6-3.3,4.1c0,2.2,2.3,3.6,7.2,4.9c5.1,1.2,9.6,1.8,15.4,3.3c5.7,1.4,10.7,3.5,14.8,6.4
	c4,2.7,6.9,6.3,6.9,12c0,4.2-1.2,7.5-4,10.7c-2.8,3.1-6.4,5.9-11.5,7.7c-5.1,1.8-13,3.2-19.7,3.2c-5.7,0-10.5-0.5-14.9-1.5l0,0
	c-4-0.9-7-2.2-10.3-4c-4.2-2.2-7.8-5.8-10.3-8.8C236.4,167.4,236.4,167.4,236.4,167.3L236.4,167.3z"
    />
    <path
        class="st0"
        d="M26,68.6c-9.4,0-17,7.6-17,17c0,9.4,7.6,17,17,17s17-7.6,17-17C43,76.2,35.4,68.6,26,68.6z M26,95.7
	c-5.6,0-10.2-4.5-10.2-10.2c0-5.6,4.6-10.2,10.2-10.2c5.6,0,10.2,4.6,10.2,10.2C36.2,91.2,31.6,95.7,26,95.7z"
    />
    <path
        class="st1"
        d="M470.4,136l-0.4-1.8l-0.6-1.8l-0.8-1.7l-1.1-1.8l-1.3-1.6l-1.5-1.4l-1.5-1.3l-1.9-1.3l-1.9-1.1l-2.1-0.9
	l-2.1-0.8l-2.3-0.6l-2.4-0.4l-2.4-0.3l-2.4-0.1h-45.2v0v62.3H423v-24.7h22.6l2.4-0.1l2.4-0.3l2.4-0.4l2.3-0.6l2.1-0.8l2.1-1l1.9-1.1
	l1.9-1.3l1.5-1.3l1.5-1.4l1.3-1.6l1.1-1.7l0.8-1.7l0.6-1.8l0.4-1.8l0.1-1.9L470.4,136z M445.6,139l-0.3,1.1l-0.5,1L444,142l-0.9,0.7
	l-1,0.5l-1.1,0.3l-1.1,0.1H423V132h16.9l1.1,0.1l1.1,0.4l1,0.5l0.9,0.8l0.7,0.9l0.5,1l0.3,1.1l0.1,1.2L445.6,139z"
    />
    <path
        class="st1"
        d="M637.6,137.2c-1.6-3.8-3.8-7.1-7-10c-3.1-2.9-6.9-5.2-11.6-6.9c-4.6-1.6-10-2.4-16-2.4
	c-7.3,0-13.7,1.3-19.3,3.9c-5.5,2.5-10,6.3-13.1,11.2c-3.1,5-4.5,10.7-4.5,17.3c0,5.3,1,9.9,2.8,14.1c1.9,4,4.5,7.4,7.9,10.1
	c3.3,2.7,7.3,4.8,11.8,6.1c4.4,1.5,9.2,2.2,14.4,2.2c6.3,0,11.8-0.9,16.6-2.7c4.7-1.8,8.5-4.2,11.4-7.2c3.1-3.1,5.2-6.7,6.7-10.7
	c1.5-4,2.2-8.4,2.2-12.9C640,144.8,639.2,140.8,637.6,137.2z M613.4,164.6c-1.9,3.6-5.4,5.5-10.3,5.5c-8.7,0-13.2-6.7-13.2-19.9
	c0-4.1,0.4-7.7,1.2-10.6c0.9-3,2.2-5.3,4.2-6.8c2-1.6,4.6-2.4,7.8-2.4c8.7,0,13.2,6.3,13.2,18.9
	C616.2,155.8,615.2,160.9,613.4,164.6z"
    />
</svg>
